import React from "react";
import { Tabs } from "antd";
import { Header } from "../components";
import UsersTab from "../components/Accounts/UsersTab";
import RolesTab from "../components/Accounts/RolesTab";
import { useAuth } from "../contexts/AuthProvider";
import { hasPermission } from "../utils/auth";

const AccountsRoles = () => {
  const { user } = useAuth();
  const canManagePermissions = hasPermission(user?.permissions, "permissions:write");

  const items = [
    {
      key: "users",
      label: "Usuarios",
      children: <UsersTab />,
    },
  ];

  if (canManagePermissions) {
    items.push({
      key: "roles",
      label: "Roles y Permisos",
      children: <RolesTab />,
    });
  }

  return (
    <div className="bg-white dark:bg-main-dark-bg rounded-lg">
      <div className="mb-4 flex justify-between items-center">
        <Header category="Página" title="Cuentas y Roles" />
      </div>
      <Tabs items={items} />
    </div>
  );
};

export default AccountsRoles;
